import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

import {getLocale} from '@epic-core/common/dist';

import StatisticsTrend from '../StatisticsTrend';
import {getDirectionStyles} from '../../../utils/ThemeUtils';
import {numberFormatter, getMappedValue} from '../../../utils/FNUtils';

const TrendWrapper = styled.span<{
    value: number;
}>`
    margin: ${p => p.theme.muiTheme.spacing(0, 1, 0, 0)};
    color: ${p =>
        getMappedValue<string>(p.value, {
            positive: p.theme.muiTheme.palette.success.light,
            negative: p.theme.muiTheme.palette.error.light,
            zero: p.theme.muiTheme.palette.dividerStrong
        })};

    & > svg {
        width: 0.8em;
        height: 0.8em;
        margin: ${p =>
            getDirectionStyles(p.theme.muiTheme.direction)(
                p.theme.muiTheme.spacing(0, 0, -1, -0.5),
                p.theme.muiTheme.spacing(0, -0.5, -1, 0)
            )};
    }
`;

export interface TrendProps {
    value: number;
}

const MyOverallHighlightTrend: FC<TrendProps> = ({value}: TrendProps) => {
    const formatNumber = numberFormatter(getLocale());

    return (
        <TrendWrapper value={value}>
            {getMappedValue<ReactNode>(value, {
                positive: <ArrowDropUpIcon />,
                negative: <ArrowDropDownIcon />
            })}
            <StatisticsTrend value={formatNumber(Math.abs(value)) || 0} />
        </TrendWrapper>
    );
};

export default MyOverallHighlightTrend;
